import { render } from "./ScholarshipMgt.vue?vue&type=template&id=a8009758&scoped=true"
import script from "./ScholarshipMgt.vue?vue&type=script&lang=js"
export * from "./ScholarshipMgt.vue?vue&type=script&lang=js"

import "./ScholarshipMgt.vue?vue&type=style&index=0&id=a8009758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8009758"]])

export default __exports__